import * as yup from "yup"
import type { Blog } from "../../types"

export function initialValuesBlog(blog?: Blog | undefined) {
  if (blog) {
    return blog
  }
  return {
    title: "",
    cover: "",
    author: "",
    reading_time: 0,
    date: "",
    draft: false,
  }
}

export function validationSchemaBlog() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    author: yup.string().required("Campo obbligatorio"),
    cover: yup.string().required("Campo obbligatorio"),
    reading_time: yup.number().nullable(),
    date: yup.string().nullable(),
  })
}
